// extracted by mini-css-extract-plugin
module.exports = {"root":"CounterpartyDetailView_root_8WTxC","inner":"CounterpartyDetailView_inner_32GLn"};